(function () {
	'use strict';

	angular.module('dcApp').factory('ngCommService', NgCommService);

	NgCommService.$inject = [
		'$log',
		'ModalService',
		'$q',
		'toaster',
		'gettextCatalog',
	];

	function NgCommService($log, ModalService, $q, toaster, gettextCatalog) {
		return {
			openPathExplorerModal: openPathExplorerModal,
			openCreateEntityFromDepotModal: createEntityFromDepot,
			notifyOnError: notifyOnError,
			notifyOnWarning: notifyOnWarning,
			notifyOnSuccess: notifyOnSuccess,
		};

		// TODO: deprecated
		function createEntityFromDepot(depot) {
			const deferred = $q.defer();
			const locals = {
				title: gettextCatalog.getString("Création Rapide d'une Entité métier"),
				entityFromDepot: {
					depotType: depot.type,
					depotId: depot.id,
					lib: depot.label,
				},
			};
			ModalService.open({
				controllerAs: 'vm',
				bindToController: true,
				templateUrl:
					'./src/components/modules/depot/entity-creator/entity-creator.html',
				controller: 'EntityCreatorController',
				disableBackdrop: true,
				locals: locals,
			}).then(
				function (path) {
					deferred.resolve(path);
				},
				function (err) {
					deferred.resolve(undefined);
					console.error(err);
				}
			);
			return deferred.promise;
		}

		function openPathExplorerModal(options) {
			const deferred = $q.defer();
			ModalService.open({
				controllerAs: 'vm',
				bindToController: true,
				templateUrl:
					'./src/components/modules/connector/remote-file-explorer/remote-file-explorer.html',
				controller: 'RemoteFilesExplorerController',
				disableBackdrop: true,
				locals: options,
			}).then(
				function (path) {
					deferred.resolve(path);
				},
				function (err) {
					deferred.resolve(undefined);
					console.error(err);
				}
			);
			return deferred.promise;
		}

		function notifyOnSuccess(str) {
			toaster.pop('success', str);
		}

		function notifyOnWarning(str) {
			toaster.pop('warning', str);
		}

		function notifyOnError(str) {
			toaster.pop('error', str);
		}
	}
})();
